module.exports = __webpack_public_path__ + "img/04设备领域.d5024d63.jpg";